import { LocalizationProvider } from "@fluent/react";
import { LoadingShim } from "@narmi/design_system";
import { useFluentLocalization } from "cerulean";
import { ReactNode } from "react";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

interface LocalizationContextProps {
  children: ReactNode;
}

function LocalizationContent(props: LocalizationContextProps) {
  const { institution, isError } = useGetInstitutionQuery();

  const { l10n, isLoading } = useFluentLocalization({
    internalName: institution.internal_name ?? "",
    s3ImagesBucket: institution.s3_images_bucket ?? "",
    productCode: "lending",
    apiUrl: `${import.meta.env.VITE_PUBLIC_API_URL}/v1/`,
  });

  if (isError) {
    return <ErrorScreen />;
  }

  return isLoading ? (
    <LoadingShim isLoading>
      <div style={{ height: "100vh" }} />
    </LoadingShim>
  ) : (
    <LocalizationProvider l10n={l10n}>{props.children}</LocalizationProvider>
  );
}

export { LocalizationContent };
